module.exports = __webpack_public_path__ + "static/media/waitListThirdScreen.2850a842.png";